<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :isForCurrentActiveUser="false"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          :showPasswordField="showPasswordField"
          class="p-3"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <el-dialog :visible.sync="setProfitRateDialogVisible" title="" top="5vh" width="75%">
      <setProfileRateForm
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Set Profit Percent for \'' + selectedUsername +'\''"
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :userId="selectedUserId"
          class="p-3"
          v-if="setProfitRateDialogVisible"></setProfileRateForm>
    </el-dialog>

    <el-dialog :visible.sync="setWorkingRatesDialogVisible" title="" top="5vh" width="75%">
      <setWorkingRates
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Set Working Destinations Rates For \'' + selectedUsername  + '\''"
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :userId="selectedUserId"
          class="p-3"
          v-if="setWorkingRatesDialogVisible"></setWorkingRates>
    </el-dialog>

    <el-dialog :append-to-body="true" :visible.sync="viewUserTestsDialogVisible" custom-class="bg-light-gray" title="" top="5vh" width="75%">
      <broadcastHistory
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Broadcast History for ' + selectedUsername "
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :statusId="0"
          :userId="selectedUserId"
          class="p-3"
          v-if="viewUserTestsDialogVisible"></broadcastHistory>
    </el-dialog>

    <app-board style="border-radius: 0; padding: 5px">
      <el-row>
        <el-col :span="12">
          Users List
        </el-col>
        <el-col :span="12" class="text-right">
          <el-button type="primary" @click="createAction" icon="el-icon-plus" size="small">Create</el-button>
        </el-col>
      </el-row>

    </app-board>
    <app-board style="border-radius: 0; padding-bottom: 10px">
      <div class="row m-0" style="height: 70px;">
        <div class="col-12 col-md-4">
          <span style="position: absolute"> Search </span>
          <dg-text-field
              class="m-0 p-0"
              :field_span="22"
            :label_span="22"
              :liveUpdate="true"
              @amUpdated="userSearchUpdated"
              field_mark=""
              placeholder="search username or display name"></dg-text-field>
        </div>
        <!--<div class="col-12 col-md-3">
          <dg-select-field
              :control="control"
              :field_span="22"
            :label_span="22"
              :options="profilesOptionsList"
              :translateLabels="false"
              @amUpdated="filterByProfileUpdated"
              field_mark=""
              :translateLabel="false"
              label="Filter Profile"
              name="destination"
              placeholder="Filter By Profile"
              rules=""></dg-select-field>
        </div>-->
        <div class="col-12 col-md-5 mt-4">
          <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
        </div>
      </div>
    </app-board>

<!--    :default-sort="{prop: 'display_name', order: 'descending'}"-->
    <el-table
        :data="tableData"
        border
        cell-class-name="p-1"
        stripe
        style="width: 100%">
      <el-table-column
          label="Display"
          prop="display_name"
          sortable
          width="180">
      </el-table-column>
      <el-table-column
          label="Username"
          prop="username"
          width="180">
      </el-table-column>
      <el-table-column
          label="Profile"
          prop="profile_caption"
          width="180">
      </el-table-column>
      <el-table-column
          label="Email"
          prop="email"
          width="230">
      </el-table-column>
      <el-table-column
          label="Created"
          prop="created_at"
          width="180">
      </el-table-column>
      <el-table-column
          align="right"
          label="Actions"
          prop="">
        <template slot-scope="scope">
          <vDropdown :actionsHandler="actionsHandler" :items="usersActions" :params="{data: scope.row, rowIndex: scope.$index + 1} "></vDropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import fieldController from "devegram-vue-data-collecter-eui/src/mixins/fieldController";

export default {
  mixins: [fieldController],
  components: {
    broadcastHistory: () => import('@/modules/voip-testing-panel/broadcast-history/page/View'),
    setProfileRateForm: () => import('@/modules/user-reseller-features/set-profit-rate/View'),
    setWorkingRates: () => import('@/modules/user-reseller-features/set-working-rates/View'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    vDropdown: () => import('@/components/button-dropdown/View')
  },
  data() {
    return {
      usersActions: [
        {
          label: 'View Tests',
          icon: 'el-icon-view',
          action: 'viewUserTests'
        },
        {
          label: 'Edit Profile',
          icon: 'el-icon-edit',
          action: 'editAction'
        },
        {
          label: 'Remove',
          icon: 'el-icon-delete',
          action: 'removeAction'
        }
      ],
      tableData: [],
      control: this,
      profilesOptionsList: [{ label: 'None', value: ''},...$store.state['user-state'].usersProfiles] ,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      showPasswordField: false,
      selectedUsername: ' - ',
      selectedUserId: null,
      setProfitRateDialogVisible: false,
      viewUserTestsDialogVisible: false,
      setWorkingRatesDialogVisible: false,
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      filterByProfileId: '',
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    updateFusionField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.id,
        data
      }

      this.updateFusionEntity(apiParams).then(r => {
        afterSave()
      })
    },
    setTableFusionServerFormatter(row, column) {
      return $store.state['user-state'].usersFusionServers[row.id][column.property]
    },
    setTableVOSServerProp(id, property) {
      return $store.state['user-state'].usersVOSserver[id][property]
    },
    setTableFusionServerProp(id, property) {
      return $store.state['user-state'].usersFusionServers[id][property]
    },
    filterByProfileUpdated(inputField) {
      this.filterByProfileId = inputField.field.field_value
      this.getEntityListData(1)
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch, profileId: this.filterByProfileId}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.tableData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true

      /*this.getUsersVOSserver({records: response.rows}).then(response => {
        this.setStateUsers({key: 'usersVOSserver', value: response})
      })*/
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions('user-state', {setStateUsers: 'setState'}),
    ...$mapActions('voip-testing-panel-api', {
      getUsersFusionServer: 'getUsersFusionServer',
    }),
    ...$mapActions('admin-gl-users-panel-api', {
      getEntityList: 'list',
      getUsersVOSserver: 'getUsersVOSserver',
    }),
    ...$mapActions('voip-fusion-server-api', {updateFusionEntity: 'update'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.navigateToPage(this.currentPage)
    },
    afterEdit(updatedData) {
      $vue.set(this.tableData, this.rowToEdit, updatedData)
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreateProfitPercent() {
      this.setProfitRateDialogVisible = false
    },
    afterCreate(newEntity) {
      this.dialogVisible = false;
      this.refreshGrid();
    },
    viewUserTests(params) {
      this.viewUserTestsDialogVisible = true
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
    },
    setWorkingRates(params) {
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
      this.setWorkingRatesDialogVisible = true
    },
    setProfitRate(params) {
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
      this.setProfitRateDialogVisible = true
    },
    createAction(params) {
      this.showPasswordField = true;
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
    },
    editAction(params) {
      this.showPasswordField = false
      this.editMode = true

      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      this.dialogVisible = true;
    },
    removeAction(params) {
      this.$confirm('This will permanently delete this user. Continue?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
          // this.tableData.splice(params.rowIndex, 1);
          this.refreshGrid()
          this.recordsCounter -= 1;
          notify({
            type: 'success',
            title: this.$ml.get('deleted'),
          });
        })
      }).catch(() => {});
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
